import { render, staticRenderFns } from "./coachWork.vue?vue&type=template&id=3ee13fdc&scoped=true&"
import script from "./coachWork.vue?vue&type=script&lang=js&"
export * from "./coachWork.vue?vue&type=script&lang=js&"
import style0 from "./coachWork.vue?vue&type=style&index=0&id=3ee13fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee13fdc",
  null
  
)

export default component.exports